<!--  -->
<template>
  <div class="wrapper box_v">
    <div class="title">
      <page-head title="人员详情" :show-back="true"></page-head>
    </div>
    <div class="status-box" v-if="peopleStatus.type">
      <Alert :type="peopleStatus.type" show-icon>
        {{peopleStatus.label}}
        <template slot="desc" v-if="peopleStatus.type == 'error'">
          {{people.checkMsg}}
          <div style="margin-top:10px">
            <Button type="plain" @click="showShenheModal">编辑</Button>
          </div>
        </template>
      </Alert>
    </div>
    <div class="card-box" style="position: relative;min-height: 100px">
      <Card dis-hover :padding="20">
        <div style="position: relative;">
          <div class="box">
            <div class="subtitle box box_f1">基本信息</div>
            <!--checkStatus:0不通过 1 通过 2待审核-->
            <Button
              class="bkcc-btn"
              @click="checkPeople(1,0)"
              v-if="people.checkStatus != 1"
              :Loading="isLoading"
            >审核通过</Button>
            <Button
              class="bkcc-btn"
              @click="showShenheModal"
              v-if="people.checkStatus == 2"
              :Loading="isLoading"
            >审核不通过</Button>
            <Button
              class="bkcc-btn"
              @click="showShenheModal"
              v-if="people.checkStatus == 1"
              :Loading="isLoading"
            >取消审核</Button>
            <Button class="bkcc-btn" @click="exportPeopleCard" :Loading="isLoading">下载登记卡</Button>
            <Button class="bkcc-btn" @click="editInfo" :Loading="isLoading">编辑</Button>
          </div>
          <Form>
            <row>
              <i-col span="8" v-if="setting.headPicUrl">
                <FormItem label="照片" prop="headPicUrl">
                  <img
                    class="headPicUrl"
                    :src="people.headPicUrl ||require('@/assets/images/default_avatar.jpg')"
                    @click.stop="clickPic('headPicUrl')"
                  />
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.name">
                <FormItem label="姓名" prop="host">
                  <div class="detail">{{people.name?people.name:'无'}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.sex">
                <FormItem label="性别" prop="sex">
                  <div class="detail">{{people.sex?'男':'女'}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.cardno">
                <FormItem label="身份证号" prop="host">
                  <div class="detail">{{people.cardno?people.cardno:'无'}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.birthday">
                <FormItem label="出生日期" prop="birthday">
                  <div class="detail">{{people.birthday?people.birthday:'无'}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.nationalId">
                <FormItem label="民族" prop="nationalId">
                  <div class="detail">{{national[people.nationalId]}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.phone">
                <FormItem label="联系电话" prop="phone">
                  <div class="detail">{{people.phone?people.phone:'无'}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.phone2">
                <FormItem label="联系电话2" prop="phone2">
                  <div class="detail">{{people.phone2?people.phone2:'无'}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.workPlace">
                <FormItem label="工作单位" prop="workPlace">
                  <div class="detail">{{people.workPlace?people.workPlace:'无'}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.idCardNOUpPicUrl">
                <FormItem label="身份证正面" prop="idCardNOUpPicUrl">
                  <img
                    v-if="people.idCardNOUpPicUrl"
                    class="headPicUrl"
                    :src="people.idCardNOUpPicUrl"
                    @click.stop="clickPic('idCardNOUpPicUrl')"
                  />
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.idCardNODownPicUrl">
                <FormItem label="身份证反面" prop="idCardNODownPicUrl">
                  <img
                    v-if="people.idCardNODownPicUrl"
                    class="headPicUrl"
                    :src="people.idCardNODownPicUrl"
                    @click.stop="clickPic('idCardNODownPicUrl')"
                  />
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.employeeHealthyPicUrl">
                <FormItem label="健康证明" prop="employeeHealthyPicUrl">
                  <img
                    v-if="people.employeeHealthyPicUrl"
                    class="headPicUrl"
                    :src="people.employeeHealthyPicUrl"
                    @click.stop="clickPic('employeeHealthyPicUrl')"
                  />
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.returnWorkTime">
                <FormItem label="复工复业时间" prop="returnWorkTime">
                  <div class="detail">{{miment(people.returnWorkTime).format('YYYY-MM-DD')}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.place4BeforeReturnWork">
                <FormItem :label="'复工复业前居住地'" prop="place4BeforeReturnWork">
                  <div class="detail">{{people.place4BeforeReturnWork}}</div>
                </FormItem>
              </i-col>

              <i-col span="8" v-if="setting.needGo2Work">
                <FormItem label="是否需要上班" prop="needGo2Work">
                  <div class="detail">{{people.needGo2Work==1?'是':'否'}}</div>
                </FormItem>
              </i-col>
              <i-col
                span="8"
                v-if="(setting.needGo2Work && people.needGo2Work==1) || (!setting.needGo2Work && setting.workPromisePicUrl)"
              >
                <FormItem label="证明" prop="workPromisePicUrl">
                  <img
                    v-if="people.workPromisePicUrl"
                    class="headPicUrl"
                    :src="people.workPromisePicUrl"
                    @click.stop="clickPic('workPromisePicUrl')"
                  />
                </FormItem>
              </i-col>
            </row>
          </Form>
          <Form v-if="isShowAll">
            <row>
              <i-col span="8" v-if="$store.state.apptype!='ctt'">
                <FormItem label="所属小区" prop="zoneName">
                  <div class="detail">{{people.zoneName?people.zoneName:'无'}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.domicilePalce">
                <FormItem label="户籍地" prop="domicilePalce">
                  <div class="detail">{{people.domicilePalce?people.domicilePalce:'无'}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.address">
                <FormItem label="现居住地址" prop="address">
                  <div class="detail">{{people.address?people.address:'无'}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.buildingNO">
                <FormItem label="楼栋号" prop="buildingNO">
                  <div class="detail">{{people.buildingNO?people.buildingNO:'无'}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.unitNO">
                <FormItem label="单元号" prop="unitNO">
                  <div class="detail">{{people.unitNO?people.unitNO:'无'}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.roomNO">
                <FormItem label="房间号" prop="roomNO">
                  <div class="detail">{{people.roomNO?people.roomNO:'无'}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.liveType">
                <FormItem label="居住类型" prop="liveType">
                  <div class="detail">{{liveType[people.liveType]}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.familyNum">
                <FormItem label="家庭成员" prop="familyNum">
                  <div class="detail">{{people.familyNum?people.familyNum:'无'}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.familyMember">
                <FormItem label="家庭成员姓名" prop="familyMember">
                  <div class="detail">{{people.familyMember?people.familyMember:'无'}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.contact">
                <FormItem label="过去两周内，接触情况" prop="contact">
                  <div class="detail">{{handleContact(people.contact)}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.symptomSelf">
                <FormItem label="自身或家人症状" prop="symptomSelf">
                  <div class="detail">{{handleSymptom(people.symptomSelf)}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.symptomFamily">
                <FormItem label="家人症状" prop="symptomFamily">
                  <div class="detail">{{handleSymptom(people.symptomFamily)}}</div>
                </FormItem>
              </i-col>
              <!-- <i-col span="8" v-if="setting.symptomFamily">
                <FormItem label="发热人员处置方式" prop="handleType">
                  <div class="detail">{{handleTypeList[people.handleType]}}</div>
                </FormItem>
              </i-col>-->
            </row>
          </Form>
          <Form v-if="isShowAll">
            <row>
              <i-col span="8" v-if="setting.fever">
                <FormItem label="是否发热" prop="fever">
                  <div class="detail">{{people.fever=='1'?'是':'否'}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.handleType && people.fever=='1'">
                <FormItem label="发热人员处置方式" prop="handleType">
                  <div class="detail">{{people.handleType?people.handleType:''}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.leaveHere">
                <FormItem :label="isWuhan?'是否为近期返城人员':('近一月是否离'+cityremark)" prop="leaveHere">
                  <div class="detail">{{people.leaveHere=='1'?'是':'否'}}</div>
                </FormItem>
              </i-col>

              <i-col span="8" v-if="setting.isAddToday">
                <FormItem label="是否为当日新增人员" prop="isAddToday">
                  <div class="detail">{{people.isAddToday=='1'?'是':'否'}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.remark">
                <FormItem label="备注" prop="remark">
                  <div class="detail">{{people.remark?people.remark:'无'}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.returnTime">
                <FormItem :label="'何日离'+cityremark" prop="returnTime">
                  <div class="detail">{{people.returnTime?people.returnTime:'无'}}</div>
                </FormItem>
              </i-col>
               <i-col span="8" v-if="setting.classAndGrade && people.classAndGrade">
                <FormItem :label="'年级班级'" prop="classAndGrade">
                  <div class="detail">{{people.classAndGrade?people.classAndGrade:'无'}}</div>
                </FormItem>
              </i-col>
               <i-col span="8" v-if="setting.beenRiskAreaName">
                <FormItem :label="'去过重点地区/中高风险地区'" prop="beenRiskAreaName">
                  <div class="detail">{{people.beenRiskAreaName}}</div>
                </FormItem>
              </i-col>
            </row>
          </Form>
          <Form v-if="isShowAll && people.leaveHere == 1">
            <row>
              <i-col span="8" v-if="setting.promisePicUrl">
                <FormItem label="承诺书" prop="promisePicUrl">
                  <img
                    class="headPicUrl"
                    :src="people.promisePicUrl"
                    @click.stop="clickPic('promisePicUrl')"
                  />
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.healthyPicUrl">
                <FormItem label="健康证明" prop="healthyPicUrl">
                  <img
                    v-if="people.healthyPicUrl"
                    class="headPicUrl"
                    :src="people.healthyPicUrl"
                    @click.stop="clickPic('healthyPicUrl')"
                  />
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.leaveWay">
                <FormItem label="离开方式" prop="leaveWay">
                  <div class="detail">{{returnWay[people.leaveWay]}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.leaveTrips">
                <FormItem label="离开车次/航班号" prop="leaveTrips">
                  <div class="detail">{{people.leaveTrips?people.leaveTrips:'无'}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.stayWuHan">
                <FormItem label="是否途经/中转/停留湖北" prop="address">
                  <div class="detail">{{people.stayWuHan=='1'?'是':'否'}}</div>
                </FormItem>
              </i-col>

              <i-col span="8" v-if="setting.returnWay">
                <FormItem label="返回方式" prop="returnWay">
                  <div class="detail">{{returnWay[people.returnWay]}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.returnTrips">
                <FormItem label="返回车次/航班号" prop="returnTrips">
                  <div class="detail">{{people.returnTrips?people.returnTrips:'无'}}</div>
                </FormItem>
              </i-col>

              <i-col span="8" v-if="setting.fromWhere">
                <FormItem :label="'从何地回'+cityremark" prop="fromWhere">
                  <div class="detail">{{people.fromWhere?people.fromWhere:'无'}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.backTime">
                <FormItem :label="'回'+cityremark+'日期'" prop="backTime">
                  <div class="detail">{{people.backTime?people.backTime:'无'}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.relation">
                <FormItem :label="'回'+cityremark+'接触人员'" prop="relation">
                  <div class="detail">{{people.relation?people.relation:'无'}}</div>
                </FormItem>
              </i-col>
              <i-col span="8" v-if="setting.footprint">
                <FormItem label="所到过的区域" prop="footprint">
                  <div class="detail">{{people.footprint?people.footprint:'无'}}</div>
                </FormItem>
              </i-col>
            </row>
          </Form>
          <Form v-if="isShowAll && people.leaveHere == 1">
            <!-- <row>
              <i-col span="8" v-if="setting.remark">
                <FormItem label="备注" prop="remark">
                  <div class="detail">{{people.remark?people.remark:'无'}}</div>
                </FormItem>
              </i-col>
            </row>-->
          </Form>
          <preview-img
            :currentIndex="0"
            :imgArr="showPreview.list"
            v-if="showPreview.show"
            v-on:closePreview="closePreview"
          ></preview-img>
          <div class="box" style="justify-content: center" @click="changeShowAll">
            <div class="footer">
              <Icon :type="isShowAll?'ios-arrow-up':'ios-arrow-down'" />
              <div class="box">{{isShowAll?'收起详情':'展开详情'}}</div>
            </div>
          </div>
          <Spin fix v-if="spinShow"></Spin>
        </div>
      </Card>
    </div>
    <div class="card-box box_f1">
      <!--<tabs v-model="tab" @on-click="clickChange" :animated="false">-->
      <!--<tab-pane label="进出门记录" name="record" >-->
      <!--<Card dis-hover :padding="20">-->
      <!--<div class="table-card">-->
      <!--<Table border :columns="recordColumn" :data="recordList" :loading="isRecordLoading" ></Table>-->
      <!--<page :total="total" @on-change="pageChange" class="page" :page-size="pageSize" :current="pageNum" show-total/>-->
      <!--</div>-->
      <!--</Card>-->
      <!--</tab-pane>-->
      <!--<tab-pane label="每日防护" name="protect" >-->
      <!--<Card dis-hover :padding="20">-->
      <!--<div class="box">-->
      <!--<div class="subtitle box box_f1">每日防护</div>-->
      <!--<Button class="bkcc-btn" @click="delInfo">删除</Button>-->
      <!--<Button class="bkcc-btn" @click="addInfo">新增</Button>-->
      <!--</div>-->
      <!--<div class="table-card">-->
      <!--<Table border :columns="settingColumn" :data="healthyList" :loading="isTableLoading" @on-selection-change="selectTableItem"></Table>-->
      <!--<page :total="total" @on-change="pageChange" class="page" :page-size="pageSize" :current="pageNum" show-total/>-->
      <!--</div>-->
      <!--</Card>-->
      <!--</tab-pane>-->
      <!--</tabs>-->
      <Card dis-hover :padding="20">
        <div class="box">
          <div class="subtitle box box_f1">每日防护</div>
          <Button class="bkcc-btn" @click="delInfo">删除</Button>
          <Button class="bkcc-btn" @click="addInfo">新增</Button>
        </div>
        <div class="table-card">
          <Table
            border
            :columns="settingColumn"
            :data="healthyList"
            :loading="isTableLoading"
            @on-selection-change="selectTableItem"
          ></Table>
          <page
            :total="total"
            @on-change="pageChange"
            class="page"
            :page-size="pageSize"
            :current="pageNum"
            show-total
          />
        </div>
      </Card>
    </div>
    <Modal title="信息录入" v-model="showModal" @on-cancel="modalCancel">
      <Form :label-width="80" label-position="left">
        <FormItem label="录入日期" prop="recordTime">
          <DatePicker v-model="recordTime" format="yyyy-MM-dd" placeholder="请选择"></DatePicker>
        </FormItem>
        <div class="ivu-form-item">
          <div>是否出现发热、乏力、干咳、逐渐出现呼吸困难症</div>
          <RadioGroup v-model="fever">
            <Radio label="1">是</Radio>
            <Radio label="2">否</Radio>
          </RadioGroup>
        </div>
        <FormItem label="体温" prop="temperature">
          <InputNumber :min="35" :max="40" v-model="temp1" type="temperature" />
          <div class="temperature1">.</div>
          <InputNumber :min="0" :max="9" v-model="temp2" type="temperature" />
          <div class="temperature2">℃</div>
        </FormItem>
        <FormItem label="备注" prop="remark" v-if="fever=='1'">
          <Input v-model="remark" type="textarea" />
        </FormItem>
        <FormItem label="提交人" prop="sgName">
          <Input v-model="sgName" />
        </FormItem>
      </Form>
      <div slot="footer" class="box" style="justify-content: flex-end">
        <Button type="text" @click="modalCancel">取消</Button>
        <Button type="primary" @click="modalOk">确定</Button>
      </div>
    </Modal>
    <!-- isShowShenheModal 输入审核不通过原因的modal -->
    <Modal
      :title="people.checkStatus != 1?'审核不通过':'取消审核'"
      v-model="isShowShenheModal"
      @on-cancel="showShenheModal"
      @on-ok="checkPeople(0,0)"
    >
      <Form label-position="top">
        <FormItem :label="(people.checkStatus != 1?'审核不通过':'取消审核')+'原因（选填）'" prop="checkMsg">
          <Input v-model="checkMsg" placeholder="请输入原因" type="textarea" :autosize="{maxRows: 5}" />
        </FormItem>
      </Form>
    </Modal>
    <!-- showShenheModal 确认未满14天是否要审核的modal -->
    <Modal title="确认审核" v-model="comfirmShenheModal" @on-ok="checkPeople(1,1)">
      <div>{{modalTitle}}</div>
    </Modal>
    <Modal title="确认" v-model="delModal" @on-cancel="cancelModal" @on-ok="delPeopleHealthy">
      <div>确认删除记录吗？删除后将无法恢复</div>
    </Modal>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import pageHead from "../../../components/head";
import PreviewImg from "../../../components/previewImg";
import { Promise } from "q";
import { parse } from "path";
import miment from "miment";
var that;
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { PreviewImg, pageHead },
  data() {
    //这里存放数据
    return {
      miment,
      fromWork: false,
      showPreview: {
        show: 0,
        list: []
      }, //预览图片
      peopleStatus: {
        label: "",
        type: ""
      },
      spinShow: true,
      communityId: "",
      cityremark: sessionStorage.cityremark,
      isWuhan: sessionStorage.isWuhan && JSON.parse(sessionStorage.isWuhan),
      people: {},
      setting: {},
      isLoading: false,
      isShowAll: false, //是否展示全部详情
      /**表格相关参数 */
      healthyList: [],
      handleTypeList: {
        1: "住院治疗",
        2: "居家观察",
        4: "集中医学观察",
        8: "发热门诊隔离治疗",
        0: "无措施"
      },
      settingColumn: [
        {
          type: "selection",
          width: 70,
          align: "center"
        },
        {
          title: "是否出现发热、乏力、干咳、逐渐出现呼吸困难症",
          render: function(h, params) {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    color:
                      that.healthyList[params.index].fever == "1"
                        ? "#ff7b44"
                        : "#a1a1a1"
                  },
                  on: {
                    click: () => {
                      that.changeStatus(params.index);
                    }
                  }
                },
                that.healthyList[params.index].fever == "1" ? "是" : "否"
              )
            ]);
          }
        },
        {
          title: "体温",
          render: function(h, params) {
            return h("div", [
              h(
                "span",
                that.healthyList[params.index].temperature
                  ? (
                      parseFloat(that.healthyList[params.index].temperature) /
                      100
                    ).toFixed(1) + "℃"
                  : ""
              )
            ]);
          }
        },
        {
          title: "备注",
          render: function(h, params) {
            return h("div", [
              h(
                "span",
                that.healthyList[params.index].remark
                  ? that.healthyList[params.index].remark
                  : "无"
              )
            ]);
          }
        },
        {
          title: "提交人",
          render: function(h, params) {
            return h("div", [
              h(
                "span",
                that.healthyList[params.index].sgName
                  ? that.healthyList[params.index].sgName
                  : "本人提交"
              )
            ]);
          }
        },
        {
          title: "提交时间",
          key: "recordTime"
        },
        {
          title: "操作",
          render: function(h, params) {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94"
                  },
                  on: {
                    click: e => {
                      e.stopPropagation();
                      that.editItem(params.index);
                    }
                  }
                },
                "[编辑]"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#5e6d94",
                    marginLeft: "10px"
                  },
                  on: {
                    click: e => {
                      e.stopPropagation();
                      that.delItem(params.index);
                    }
                  }
                },
                "[删除]"
              )
            ]);
          }
        }
      ],
      recordColumn: [
        {
          title: "日期",
          key: "date"
        },
        {
          title: "时间",
          key: "time"
        },
        {
          title: "类型",
          key: "type"
        },
        {
          title: "体温",
          key: "num"
        }
      ],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      isTableLoading: false,
      /**表格相关参数结束 */
      showModal: false,
      selectId: -1,
      recordTime: "",
      fever: "2",
      remark: "",
      sgName: "",
      temp1: 36,
      temp2: 3,
      returnWay: {
        1: "飞机",
        2: "火车",
        4: "大巴",
        8: "轮船",
        16: "拼车",
        32: "自驾"
      },
      symptom: {
        1: "咳嗽",
        2: "感冒",
        4: "发烧",
        8: "乏力",
        16: "呼吸困难",
        32: "腹泻",
        64: "其他",
        0: "正常"
      },
      liveType: {
        1: "自有房屋",
        2: "租赁房屋",
        4: "借住房屋",
        8: "其它"
      },
      contact: {
        1: "接触过湖北的客人/亲人",
        2: "接触过武汉的客人/亲人",
        4: "接触过有以下症状的客人（发热、咳嗽、乏力、呼吸困难）",
        0: "无接触异常人员"
      },
      national: {},
      zoneList: [],
      isShowShenheModal: false, //审核不通过弹窗
      checkMsg: "", //审核不通过原因
      tab: "record",
      recordList: [],
      isRecordLoading: false,
      comfirmShenheModal: false, //未满14天是否审核弹窗
      modalTitle: "",
      delId: "",
      delModal: false
    };
  },
  //监听属性 类似于data概念
  computed: {
    // 控制显示的内容
    handleSymptom() {
      var that = this;
      return function(value) {
        return getIndexAry(value, that.symptom);
      };
    },
    handleContact() {
      var that = this;
      return function(value) {
        return getIndexAry(value, that.contact);
      };
    }
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    closePreview() {
      console.log("========closePreview==========");
      this.showPreview.show = 0;
    },
    clickPic(val) {
      let obj = {
        isHeight: true,
        path: ""
      };
      obj.path = this.people[val];
      // switch(val){
      //   case 0:
      //    obj.path = this.people.headPicUrl;
      //    break;
      //   case 1:
      //     obj.path = this.people.workPromisePicUrl;
      //     break;
      //   case 2:
      //     obj.path = this.people.promisePicUrl;
      //     break;
      //   case 3:
      //     obj.path = this.people.healthyPicUrl;
      //     break;
      //}
      this.showPreview.list = [obj];
      this.showPreview.show = 1;
    },
    modalOk() {
      if ((this.fever == "1" && this.remark == "") || this.sgName == "") {
        this.$Message.error("请完善信息");
        return;
      }
      let data = {
        id: this.selectId,
        epdemicPeopleId: this.$route.query.id,
        name: this.people.name,
        recordTime: this.$util.FormatDate(this.recordTime, "yyyy-MM-dd"),
        fever: this.fever,
        //"status" : 健康状况,
        remark: this.fever == "1" ? this.remark : "",
        sgName: this.sgName,
        temperature: this.temp1 * 100 + this.temp2 * 10
        //"sgId" : 社工id,
      };

      console.log(data);
      this.$post(this.urlobj.submitPeopleHealthy, data)
        .then(res => {
          this.showModal = false;
          this.$Message.success("提交成功");
          //初始化信息
          this.fever = "2";
          this.remark = "";
          this.pageNum = 1;
          this.getHealthyList();
        })
        .catch(e => {
          console.log(e);
        });
    },
    modalCancel() {
      //初始化信息
      this.fever = "2";
      this.remark = "";
      this.recordTime = new Date();
      this.showModal = false;
    },
    getFangyiDetail(id) {
      let url = this.urlobj.getFangyiDetail(id);
      this.$get(url)
        .then(res => {
          this.spinShow = false;
          this.people = res.rows[0];
          this.checkMsg = this.people.checkMsg;
          this.getStatus(this.people.checkStatus);
          this.people.handleType = this.getHandleType(this.people.handleType);
        })
        .catch(e => {
          console.log(e);
        });
    },
    getHandleType(val) {
      let label = "";
      switch (parseInt(val)) {
        case 1:
          label = "在院治疗";
          break;
        case 2:
          label = "居家观察";
          break;
        case 4:
          label = "集中医学观察";
          break;
        case 8:
          label = "发热门诊隔离治疗";
          break;
        case 0:
          lable = "无措施";
      }
      return label;
    },
    //展开收起详情
    changeShowAll() {
      this.isShowAll = !this.isShowAll;
    },
    //健康信息列表
    getHealthyList() {
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        epdemicPeopleId: this.$route.query.id,
        communityId: this.communityId
      };
      this.$post(this.urlobj.getHealthyList, data)
        .then(res => {
          this.isTableLoading = false;
          this.total = res.total;
          this.healthyList = res.rows;
          this.healthyList.forEach(item => {
            let time = item.recordTime.substring(0, item.recordTime.length - 2);
            time = time.replace(/-/g, "/");
            item.recordTime =
              this.$util.FormatDate(new Date(time), "MM-dd") +
              (parseInt(this.$util.FormatDate(new Date(time), "HH")) > 12
                ? " 下午"
                : " 上午");
          });
        })
        .catch(e => {
          console.log(e);
        });
    },
    pageChange(val) {
      this.pageNum = val;
      this.getHealthyList();
    },
    editInfo() {
      let name = this.fromWork ? "addWorker" : "addFangyi";
      this.$router.push({
        name,
        query: { id: this.$route.query.id, communityId: this.communityId }
      });
    },
    delInfo() {
      console.log("---------selectItemList-----------");
      console.log(this.selectItemList);
      let ids = this.selectItemList
        ? this.selectItemList.map(item => item.id).join(",")
        : "";
      if (!ids) {
        this.$Message.warning("请选择要操作的记录");
        return;
      }
      this.delModal = true;
      this.delId = ids;
      //this.delPeopleHealthy(ids)
    },
    addInfo() {
      this.showModal = true;
    },
    selectTableItem(value) {
      this.selectItemList = value;
    },
    editItem(idx) {
      let data = this.healthyList[idx];
      this.selectId = data.id;
      this.remark = data.remark;
      this.fever = data.fever + "";
      this.recordTime = new Date();
      this.sgName = data.sgName;
      if (data.fever == 1) {
        this.temp1 = parseInt(data.temperature / 100);
        this.temp2 = (data.temperature - this.temp1 * 100) / 10;
      }

      this.showModal = true;
    },
    delItem(idx) {
      this.delModal = true;
      this.delId = this.healthyList[idx].id;
      //this.delPeopleHealthy(this.healthyList[idx].id)
    },
    delPeopleHealthy() {
      this.$delete(this.urlobj.delPeopleHealthy + "?idList=" + this.delId)
        .then(res => {
          this.$Message.success("删除成功");
          this.pageNum = 1;
          this.getHealthyList();
        })
        .catch(e => {});
    },
    cancelModal() {},
    //审核居民信息
    checkPeople(checkStatus, isMust) {
      this.isLoading = true;
      let data = {
        ids: this.$route.query.id,
        checkStatus
      };
      if (checkStatus === 0) data.checkMsg = this.checkMsg;
      if (isMust == 1) data.isMust = 1;
      this.$post(this.urlobj.checkPeople, data)
        .then(res => {
          this.isLoading = false;
          this.$Message.success("操作成功");
          this.people.checkStatus = checkStatus;
          this.getFangyiDetail(this.$route.query.id);
        })
        .catch(e => {
          if (e.data.code == 900190) {
            this.comfirmShenheModal = true;
            this.modalTitle = e.data.message;
          }
          this.isLoading = false;
        });
    },
    //下载居民登记卡
    exportPeopleCard() {
      window.open(
        this.urlobj.exportPeopleCard +
          "?ids=" +
          this.$route.query.id +
          "&token=" +
          this.$store.state.access_token
      );
    },
    getFangyiSetting() {
      this.$get(this.urlobj.getEpidemicSetting, {
        communityId: this.communityId
      }).then(res => {
        // this.inputList = res.rows
        res.rows.forEach(item => {
          this.setting[item.fieldKey] = item.isShow;
        });
      });
    },
    getNation() {
      this.$get(this.urlobj.dictionaryList("national")).then(res => {
        res.rows.forEach(item => {
          this.national[item.id] = item.dicName;
        });
        this.getFangyiDetail(this.$route.query.id);
      });
    },
    //切换审核信息弹窗显示隐藏
    showShenheModal() {
      this.isShowShenheModal = !this.isShowShenheModal;
    },
    getStatus(checkStatus) {
      let obj = {
        type: "",
        label: ""
      };
      switch (checkStatus) {
        case 1:
          obj = {
            label: "审核通过",
            type: "success"
          };
          break;
        case 2:
          obj = {
            label: "待审核",
            type: "warning"
          };
          break;
        case 0:
          obj = {
            label: "审核未通过",
            type: "error"
          };
          break;
      }
      this.peopleStatus = obj;
    },
    clickChange(val) {
      this.tab = val;
      this.page = 1;
      // this.getSqEvent(this.selectVal)
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    console.log(sessionStorage.isWuhan);
    this.fromWork = this.$route.query.fromWork ? true : false;
    that = this;
    if (this.isWuhan) {
      this.contact[1] = "接触过确诊或疑似病例";
    }
    this.communityId = this.$route.query.communityId;

    this.getFangyiSetting();

    this.getHealthyList();
    this.recordTime = new Date();
    //this.sgName=this.$store.state.userName
    this.getNation();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};

// 对复选框数值分解
function getIndexAry(num, list) {
  let arr = Number(num)
    .toString(2)
    .split("");
  let len = arr.length - 1;
  let str = "";

  if (arr.length == 1 && arr[0] == 0) str = str + list[0] + " ";

  arr
    .map((item, index) => {
      if (+item) return +item * 2 ** (len - index);
    })
    .forEach(item => {
      if (item != undefined) str = str + list[item] + " ";
    });
  return str;
}
</script>
<style lang='less' scoped>
/deep/ .ivu-tabs-bar {
  margin-bottom: 2px;
  border-bottom: 0;
}
/deep/ .ivu-tabs-tab-active {
  color: white;
  background: #fe7d43;
  border-radius: 5px 5px 0 0;
}
/deep/ .ivu-tabs-tab-active:hover {
  color: #fff !important;
}
/deep/ .ivu-tabs-ink-bar {
  height: 0px;
}
/deep/ .ivu-tabs-nav {
  padding-left: 10px;
  color: black;
}
/deep/ .ivu-tabs-tab {
  font-weight: bold;
}
/deep/ .ivu-tabs-tab:hover {
  color: #ff7b44;
}
//@import url(); 引入公共css类
.wrapper {
  height: 100%;
}
.status-box {
  padding: 0 20px;
}
.card-box {
  margin: 0 20px 20px;
}

/deep/ .ivu-card {
  height: 100%;
}

/deep/ .ivu-card-body {
  height: 100%;
}

.subtitle {
  position: relative;
}

.subtitle::after {
  content: "";
  position: absolute;
  left: -20px;
  top: 0;
  height: 20px;
  width: 3px;
  background-color: #ff7844;
}

.detail {
  color: #666;
}

.footer {
  display: flex;
  width: 80px;
  align-items: center;
  justify-content: space-between;
}

.table-card {
  padding: 20px 0px 80px;
  position: relative;
  height: 100%;
  text-align: right;
}

.page {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
}

/deep/ .ivu-table-tip {
  overflow-x: hidden;
}
.headPicUrl {
  display: block;
  height: 80px;
  width: 80px;
}
.temperature1 {
  display: inline-block;
  width: 20px;
  font-weight: bold;
  text-align: center;
}
.temperature2 {
  display: inline-block;
  width: 40px;
  text-align: center;
  vertical-align: bottom;
}
</style>
